// extracted by mini-css-extract-plugin
export var wrapper = "styles-module__wrapper___e7x_H";
export var submit = "styles-module__submit___EW4c3";
export var sectionDivider = "styles-module__sectionDivider___P2mrv";
export var alreadyHaveAnAccount = "styles-module__alreadyHaveAnAccount___Us3Wa";